import { useContext } from "react";
import { useLoaderData } from "react-router-dom";

import MenuContext from '../../store/MenuContext';	
import TestInfoClasses from '../Tests/TestInfo.module.css';


const PostLoginMsg = (props) => {
	const menuTheme = useContext(MenuContext);

    return (
    		<div className={TestInfoClasses.testInfo} style={{paddingTop: '40px'}}>
    	    	<div className={TestInfoClasses.testInfoContent}>
    	    		<p className={TestInfoClasses.htmlText}>
					<br/><br/>
			      		<span dangerouslySetInnerHTML={{__html:props.Message}} />
			      	</p>
			     </div>
            </div>
        
    );
};

export default PostLoginMsg;
